/* trunk-ignore-all(prettier) */
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  styled,
} from "@mui/material";
import { IconButton } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";
import { signInWithGithub, signInWithGoogle } from "./OAuth";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

const AuthContainer = styled("div")(() => ({
  display: "flex",
  height: "100vh",
}));

const Panel = styled("div")(({ theme, bgColor, textColor }) => ({
  flex: 1, // Simplified for equal 50% distribution
  backgroundColor: bgColor || theme.palette.background.paper,
  color: textColor || theme.palette.text.primary,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: "2rem",
  boxSizing: "border-box",
}));

const FormBox = styled(Box)(() => ({
  width: "100%",
  maxWidth: 400,
}));

const AuthTitle = styled(Typography)(({ theme }) => ({
  fontSize: "2.5rem",
  fontWeight: "bold",
  marginBottom: theme.spacing(4),
  textAlign: "center",
}));

const AuthQuestion = styled("p")(({ theme }) => ({
  margin: theme.spacing(2, 0),
  fontSize: "1rem",
  textAlign: "center",
}));

const Register = ({ onRegister }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
      });

      if (error) throw error;
      // You might want to show a message here asking the user to check their email for verification
      onRegister(data.user);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleOAuthError = (error) => {
    setError(error.message);
  };

  const handleSignUpWithGithub = async () => {
    try {
      await signInWithGithub();
    } catch (error) {
      handleOAuthError(error);
    }
  };

  const handleSignUpWithGoogle = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      handleOAuthError(error);
    }
  };

  return (
    <AuthContainer>
      <Panel>
        <FormBox component="form" onSubmit={handleSubmit}>
          <AuthTitle>Create Account</AuthTitle>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="confirmPassword"
            label="Confirm Password"
            type="password"
            id="confirmPassword"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign Up
          </Button>
          <AuthQuestion>Or sign up with</AuthQuestion>
          <Box
            sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}
          >
            <IconButton onClick={handleSignUpWithGithub}>
              <GitHubIcon />
            </IconButton>
            <IconButton onClick={handleSignUpWithGoogle}>
              <GoogleIcon />
            </IconButton>
          </Box>
          <AuthQuestion>
            Already have an account? <Link to="/login">Sign In</Link>
          </AuthQuestion>
        </FormBox>
      </Panel>

      <Panel bgColor="#000000" textColor="#ffffff">
        <Typography variant="h3" sx={{ textAlign: "center" }}>
          Welcome to AISecurityPulse
        </Typography>
      </Panel>
    </AuthContainer>
  );
};

export default Register;
